export default __webpack_public_path__ + "static/media/1052.9ac1061f.png";